<template>
  <div class="card" :style="cardStyles">
    <div>
      <img :src="CardContent[type].icon" :alt="type" class="img-card"/>
      <h4>{{ CardContent[type].title.text }}</h4>
      <p>
        {{ CardContent[type].description.text }}
      </p>

      <footer class="links">
        <a
          v-for="link in CardContent[type].links"
          :key="link.url"
          :href="link.url"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ link.text }}
          <img :src="externalLinkImage" alt="open" />
        </a>
      </footer>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { EmailSupport, WebChatSupport, ServiceSupport } from "@/app/common/utils/content";

import externalLinkImage from "@/app/supervision/assets/external-link.svg?url";

type CardType = "mail" | "webchat" | "service";

const props = defineProps<{
  type: CardType;
}>();

const CardContent: Record<CardType, typeof EmailSupport> = {
  mail: EmailSupport,
  webchat: WebChatSupport,
  service: ServiceSupport,
};

const cardStyles = computed(() => {
  const content = CardContent[props.type];

  return { "--bg-color": content.backgroundColor, "--border-color": content.borderColor };
});

// const handleClick = () => {
//   const url = CardContent[props.type].url;
//   const target = url.includes("mailto") ? "_self" : "_blank";

//   window.open(url, target, "noopener noreferrer");
// };
</script>

<style scoped lang="sass">
.card
  padding: 24px
  border: 1px solid var(--border-color)
  border-radius: 20px
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15)
  background-color: var(--bg-color)
  // cursor: pointer
  max-width: 348px
  display: grid
  grid-template-columns: auto 1fr
  place-items: center
  gap: 8px

.img-card
  margin-bottom: 16px

h4
  font-size: 16px
  font-weight: 600
  margin-bottom: 4px

p
  margin: 0
  color: #000000A6

.links
  display: flex
  justify-content: space-between
  margin-top: 16px

  & > a
    display: flex
    align-items: center
    gap: 4px
</style>
